import { PeriodParam } from "../../follow-ups";
import { IFrameworkResource } from "../../frameworks/types/IFrameworkResource";
import { ISkillResource } from "../../skills";
import { IUserResource } from "../../users/types/IUserResource";
import {
    createApiQueryHook,
    IApiQueryFunction,
    IOrderable,
    IPaginateable,
    mapOrder,
    mapPagination,
} from "../../utils/api";
import { mapRelationalFilter, RelationalFilter } from "../../utils/filters";
import { serialize } from "../../utils/url";
import { ISelfEvaluationList } from "../types/ISelfEvaluationList";

export interface ISelfEvaluationListQueryParameters extends IPaginateable, IOrderable<"updatedAt" | "createdAt"> {
    filters?: {
        frameworks?: RelationalFilter<IFrameworkResource>;
        skills?: RelationalFilter<ISkillResource>;
        officialTitle?: string;
        learnerUuid?: RelationalFilter<IUserResource>;
        periodStart?: {
            date?: string;
            param?: PeriodParam;
        };
        periodEnd?: {
            date?: string;
            param?: PeriodParam;
        };
    };
}

export type ISelfEvaluationListQueryResult = ISelfEvaluationList;

const mapFilters = (filters: ISelfEvaluationListQueryParameters["filters"]) => {
    const { frameworks, skills, officialTitle, learnerUuid, periodEnd, periodStart } = filters ?? {};

    return {
        "skillLevels.skill.uuid": mapRelationalFilter(skills),
        "skillLevels.skill.frameworks.uuid": mapRelationalFilter(frameworks),
        "skillLevels.skill.officialTitle": officialTitle,
        "learner.uuid": mapRelationalFilter(learnerUuid),
        [`periodStart[${periodStart?.param ?? PeriodParam.BEFORE}]`]: periodStart?.date,
        [`periodEnd[${periodEnd?.param ?? PeriodParam.BEFORE}]`]: periodEnd?.date,
    };
};

export const selfEvaluationListQuery: IApiQueryFunction<ISelfEvaluationListQueryParameters> = ({
    pagination,
    order,
    filters,
}) => {
    return {
        method: "GET",
        url: `/self_evaluations${serialize(
            {
                ...mapPagination(pagination),
                ...mapOrder(order),
                ...mapFilters(filters),
            },
            true,
        )}`,
    };
};

export const useSelfEvaluationListQuery = createApiQueryHook<
    ISelfEvaluationListQueryParameters,
    ISelfEvaluationListQueryResult
>(selfEvaluationListQuery);
